import '../assets/scss/components/ordersummarycomponentlist.scss';

export default function OrderSummaryComponentList(props) {

    //#region Set Order Summary

    let orderSummaryItems = [];
    let itemNames;
    let isIntegrated;
    let isRequired;

    if (props.buildItemSummary != null)
    {
        for (let c = 0; c < props.buildItemSummary.categories.length; c++)
        {

            let category = props.buildItemSummary.categories[c];

            itemNames = [];
            isIntegrated = false;
            isRequired = category.isRequired;

            for (let i = 0; i < props.buildItemSummary.categories[c].items.length; i++)
            {

                let item = props.buildItemSummary.categories[c].items[i];

                if (item.id !== 0)
                {
                    // real product / selected item
                    if (item.quantity > 1)
                    {
                        itemNames.push(item.name + " x " + item.quantity);
                    }
                    else
                    {
                        itemNames.push(item.name);
                    }
                }
                else
                {
                    // integrated on another component / bundles (e.g. stock cooler or graphics on cpu)
                    itemNames.push(item.name);
                    isIntegrated = true;
                }

            }

            orderSummaryItems.push({ key: category.name, isIntegrated: isIntegrated, isRequired: isRequired, itemCount: itemNames.length, items: itemNames })

        }

        //console.log("-------------------------");
        //console.log(orderSummaryItems);
        //console.log("-------------------------");

    }
    else
    {
        return (<></>);
    }

    //#endregion Set Order Summary

    const handleCategoryClick = (categoryName) => 
    {
        // only trigger function if one was set
        if (props.goToCategory)
            props.goToCategory(categoryName);
    }

    let viewModeClass;

    // mode 0 is default (order summary on main content), 1 is summary mode
    if (props.viewMode && props.viewMode === 1)
        viewModeClass = "summary-view-mode";
    else 
        viewModeClass = "default-view-mode";

    return (
        <div className={ viewModeClass }>
        {
            orderSummaryItems.map((category, index) =>
            {
                let categoryClass = (category.items.length > 0) ? "ms-auto custom-color-light" : "ms-auto text-danger";
                let notSelectedText = "";

                if (category.items.length > 0)
                {
                    if (category.isIntegrated)
                    {
                        categoryClass = "ms-auto text-muted";
                    }
                    else
                    {
                        categoryClass = "ms-auto custom-color-light";
                    }
                }
                else
                {
                    if (category.isRequired)
                    {
                        categoryClass = "ms-auto text-danger";
                        notSelectedText = "Not selected - required!";
                    }
                    else
                    {
                        categoryClass = "ms-auto text-muted";
                        notSelectedText = "Not selected";
                    }
                }

                let itemClass = "main-order-summary-text text-start d-flex w-100 text-casing fw-semibold border-bottom border-silver-2 py-2";

                if (index + 1 === orderSummaryItems.length)
                    itemClass = itemClass + " border-bottom-0";

                if (category.items.length > 0)
                    return (
                        <div key={category.key + "_" + index} onClick={() => { handleCategoryClick(category.key) } } className={itemClass}>
                            <span className="summary-category-name-text custom-color-light pe-2 pe-sm-3" style={{ whiteSpace: 'nowrap' }}>{category.key}</span>
                            {
                                <span className={categoryClass + " text-end"}>
                                    {
                                        category.items.map((productName, index) =>
                                        {
                                            let productText = productName;
                                            return <span key={productName + "__" + index}>{productText}<br></br></span>
                                        })
                                    }
                                </span>
                            }
                        </div>
                    )
                else
                    return (
                        <div key={category.key + "_" + index} onClick={() => { handleCategoryClick(category.key) } } className={itemClass}>
                            <span className="summary-category-name-text text-muted pe-2 pe-sm-3">{category.key}</span><span className={categoryClass + " text-end"}>{notSelectedText}</span>
                        </div>
                    )

            })
        }
        </div>

    )
}